module.exports = __webpack_public_path__ + "static/media/shurukuang.acfc0624.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/shurukuang.png
// module id = 330
// module chunks = 2